module.exports = __webpack_public_path__ + "img/chameleon.1b919ab3.png";